import autoPlay from "./autoPlay.ts";
import close from "./close.ts";
import createStream from "./createStream.ts";
import getName from "./getName.ts";
import getValidNumGamesPlayoffSeries from "./getValidNumGamesPlayoffSeries.ts";
import setRepeatSeason from "./setRepeatSeason.ts";
import loadGameAttributes from "./loadGameAttributes.ts";
import remove from "./remove.ts";
import setGameAttributes from "./setGameAttributes.ts";
import swapWorstRoster from "./swapWorstRoster.ts";
import updateMeta from "./updateMeta.ts";

export default {
	autoPlay,
	close,
	createStream,
	getName,
	getValidNumGamesPlayoffSeries,
	setRepeatSeason,
	loadGameAttributes,
	remove,
	setGameAttributes,
	swapWorstRoster,
	updateMeta,
};
